import React from 'react';
import { FaSyncAlt, FaFilter } from 'react-icons/fa';
import { SearchBar } from '../../../components/common';

const AdminToolbar = ({
  filters,
  activeFilter,
  onFilterChange,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  onRefresh,
  isRefreshing,
  isLoading,
  actions,
}) => (
  <div className="bg-white rounded-xl border border-gray-200/80 shadow-sm mb-5">
    <div className="p-4 space-y-3">
      {/* Filters row */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-center gap-2 shrink-0">
          <FaFilter className="text-gray-400 text-xs" />
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Filter</span>
        </div>
        <div className="flex gap-1.5 flex-wrap flex-1">
          {filters.map(({ key, label, count, activeClass }) => (
            <button
              key={key}
              type="button"
              onClick={() => onFilterChange(key)}
              className={`px-3 py-1.5 rounded-lg font-medium text-xs transition-all flex items-center gap-1.5 ${
                activeFilter === key
                  ? activeClass || 'bg-designer-dark text-white'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100 border border-gray-200/60'
              }`}
            >
              {label}
              <span
                className={`text-[10px] px-1.5 py-0.5 rounded-full font-bold ${
                  activeFilter === key ? 'bg-white/20' : 'bg-white text-gray-500 border border-gray-200/60'
                }`}
              >
                {count}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Search + actions row */}
      <div className="flex items-center gap-2 pt-1 border-t border-gray-100">
        <div className="flex-1 min-w-0">
          <SearchBar
            value={searchValue}
            onChange={onSearchChange}
            placeholder={searchPlaceholder}
            compact
          />
        </div>
        {actions}
        <button
          type="button"
          onClick={onRefresh}
          disabled={isRefreshing || isLoading}
          className="p-2.5 bg-gray-50 hover:bg-gray-100 text-gray-500 hover:text-designer-primary rounded-xl border border-gray-200/60 transition-all disabled:opacity-50 disabled:cursor-not-allowed shrink-0"
          title="Refresh"
        >
          <FaSyncAlt className={`w-3.5 h-3.5 ${isRefreshing ? 'animate-spin' : ''}`} />
        </button>
      </div>
    </div>
  </div>
);

export default AdminToolbar;
